/* global STUDIO_5_URL, NODE_ENV */

import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import {
  AccountMenu as NavAccountMenu,
  AccountMenuItem,
} from '@studio/navigation';
import { ExternalLink } from '@studio/legacy-components';

import { Link } from 'react-router-dom';
import { selectAccount } from 'next/entities/account';
import { selectAccounts } from 'next/entities/accounts';
import { logout, selectUser } from 'next/entities/user';
import { S5_ACCOUNT_SETTINGS, selectFeature } from 'next/entities/features';

const getStudio5Url = () => {
  const STUDIO5_LOCAL = 'http://localhost:3008';
  const isDev = NODE_ENV === 'development';

  return isDev ? STUDIO5_LOCAL : STUDIO_5_URL;
};

const AccountMenu = ({
  account,
  accounts,
  user,
  hasS5AccountSettings,
  onLogout,
}) => {
  const studio5Url = getStudio5Url();

  return (
    <NavAccountMenu
      account={account}
      accounts={accounts}
      user={user}
      onLogout={onLogout}
      Link={Link}
    >
      <AccountMenuItem
        label="Settings"
        path={`/settings/account?account=${account?.id}`}
        Link={Link}
        baseUrl={studio5Url}
        external={hasS5AccountSettings}
      />
      <AccountMenuItem label="Diagnostics" path="/diagnostics" Link={Link} />
      <AccountMenuItem
        label="Appcues status"
        Link={ExternalLink}
        baseUrl="https://status.appcues.com"
        icon={false}
        external
      />
    </NavAccountMenu>
  );
};

const mapStateToProps = state => ({
  account: selectAccount(state),
  accounts: selectAccounts(state),
  user: selectUser(state),
  hasS5AccountSettings: selectFeature(state, S5_ACCOUNT_SETTINGS),
});

const mapDispatchToProps = {
  onLogout: logout,
};

AccountMenu.propTypes = {
  account: PropTypes.shape({ company: PropTypes.string, id: PropTypes.string }),
  accounts: PropTypes.objectOf(PropTypes.shape({ company: PropTypes.string })),
  user: PropTypes.shape({
    email: PropTypes.string,
    fullname: PropTypes.string,
  }),
  hasS5AccountSettings: PropTypes.bool,
  onLogout: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountMenu);
